import { useMemo, useState } from 'react';
import styles from './PublicShare.module.css';
import { shareCoin } from '../../utils/coinMedia';

// Pass `coin` (a coin or reward object) to let the native share sheet attach the
// best media for the destination — GIF / MP4 / static image — next to the link.
export default function ShareMenu({ url, title, text, compact = false, coin = null }) {
    const [copied, setCopied] = useState(false);
    const shareUrl = url || window.location.href;
    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedText = encodeURIComponent(text || title || 'Check this out on Aluvo.');

    const links = useMemo(() => ({
        x: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        sms: `sms:?&body=${encodedText}%20${encodedUrl}`,
    }), [encodedText, encodedUrl]);

    async function copyLink() {
        try {
            await navigator.clipboard.writeText(shareUrl);
        } catch {
            const input = document.createElement('input');
            input.value = shareUrl;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 1800);
    }

    async function nativeShare() {
        const result = await shareCoin({ coin, title, text, url: shareUrl });
        if (result === 'unsupported') copyLink();
    }

    return (
        <div className={`${styles.shareMenu} ${compact ? styles.compactShare : ''}`}>
            <button onClick={nativeShare}>Share</button>
            <button onClick={copyLink}>{copied ? 'Copied!' : 'Copy link'}</button>
            <a href={links.x} target="_blank" rel="noopener noreferrer">X</a>
            <a href={links.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href={links.sms}>Text</a>
        </div>
    );
}
